export const FEATURE_NAME = "home-page-redesign";

export const withNamespace = str => `${FEATURE_NAME}/${str}`;
